import { ChangeDetectionStrategy, Component, EventEmitter, OnInit, Output } from '@angular/core';

import { Vehicle } from '@commons/models/domain/Vehicle';
import { TranslateService } from '@ngx-translate/core';

export const LOCAL_STORAGEV_CONFIG_VALULE = 'config-list-vehicle';

export enum VehicleListTypeDataVisible {
  Speed = 12,
  Mileage = 5,
  Turnover = 7,
  Voltage = 6,
  Etoll = 19,
};

@Component({
  selector: 'app-configurator-list-vehicle',
  templateUrl: './configurator-list-vehicle.component.html',
  styleUrls: ['./configurator-list-vehicle.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class ConfiguratorListVehicleComponent implements OnInit {
  public readonly VEHICLE_LIST_TYPE_DATA = VehicleListTypeDataVisible;

  private readonly MOCK_VEHICLE_DATA: any = {
    "Id": 682,
    "CS": 0,
    "LD": "",
    "DR": 0,
    "LL": {
        "Id": 5121,
        "Lt": 51.9599333,
        "Ln": 20.1481116,
        "Cr": "",
        "Ct": this.translate.instant('currentPositionCars'),
        "Ds": "",
        "Br": "",
        "St": "",
        "Rd": "",
        "Zp": "",
        "Hs": ""
    },
    "MS": 0,
    "Nm": this.translate.instant('labels.vehicle'),
    "RN": null,
    "St": 1,
    "MF": null,
    "SentGeoId": "tekom01_682",
    "SN": "357544370807782",
    "BN": "Z22-HP91TT-3",
    "DP": "3628",
    "RE": true,
    "SE": true,
    "ES": 2,
    "SG": 2,
    "TS": -1,
    "ControlIndicators": [],
    "LastUpdated": "2024-02-06T13:55:46Z",
    "LastUpdatedFrom": "INDICATORS_GEO_LOAD",
    "LastDriver": {
      FN: this.translate.instant('labels.driver'),
    }
  };

  @Output() private onSubmit$: EventEmitter<VehicleListTypeDataVisible> = new EventEmitter();
  @Output() private onHide$: EventEmitter<void> = new EventEmitter();

  public options = [
    {
      title: this.translate.instant('vehicle-indicator.speed'),
      labelId: 'speed',
      value: VehicleListTypeDataVisible.Speed,
      description: '90 km/h'
    },
    {
      title: this.translate.instant('vehicle-indicator.counter'),
      labelId: 'mileage',
      value: VehicleListTypeDataVisible.Mileage,
      description: '123 545 km'
    },
    {
      title: this.translate.instant('vehicle-indicator.rpm'),
      labelId: 'Turnover',
      value: VehicleListTypeDataVisible.Turnover,
      description: '900 rpm'
    },
    {
      title: this.translate.instant('vehicle-indicator.voltage'),
      labelId: 'Voltage',
      value: VehicleListTypeDataVisible.Voltage,
      description: '12,0 V'
    },
  ];

  public selectedOptionValue: VehicleListTypeDataVisible;
  public vehicle: Vehicle;

  constructor(private translate: TranslateService) {
    this.vehicle = new Vehicle(this.MOCK_VEHICLE_DATA, this.translate);
  }

  ngOnInit(): void {
    this.selectedOptionValue = Number(localStorage.getItem(LOCAL_STORAGEV_CONFIG_VALULE) || VehicleListTypeDataVisible.Speed);
  }

  public submit(): void {
    this.onSubmit$.emit(this.selectedOptionValue);
    localStorage.setItem(LOCAL_STORAGEV_CONFIG_VALULE, `${ this.selectedOptionValue }`);
  }

  public onHide(): void {
    this.onHide$.emit();
  }

}
